// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/assets_service.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { FinalizeProjectImageRequestSchema, FinalizeProjectImageResponseSchema } from "./finalize_project_image_pb";
import { file_vision_assets_v1_finalize_project_image } from "./finalize_project_image_pb";
import type { RotateProjectImageRequestSchema, RotateProjectImageResponseSchema } from "./rotate_project_image_pb";
import { file_vision_assets_v1_rotate_project_image } from "./rotate_project_image_pb";
import type { ListProjectImagesRequestSchema, ListProjectImagesResponseSchema } from "./list_project_images_pb";
import { file_vision_assets_v1_list_project_images } from "./list_project_images_pb";
import type { CategorizeProjectImagesRequestSchema, CategorizeProjectImagesResponseSchema } from "./categorize_project_images_pb";
import { file_vision_assets_v1_categorize_project_images } from "./categorize_project_images_pb";
import type { FinalizeReferenceImageRequestSchema, FinalizeReferenceImageResponseSchema } from "./finalize_reference_image_pb";
import { file_vision_assets_v1_finalize_reference_image } from "./finalize_reference_image_pb";
import type { ListReferenceBankRequestSchema, ListReferenceBankResponseSchema } from "./list_reference_bank_pb";
import { file_vision_assets_v1_list_reference_bank } from "./list_reference_bank_pb";
import type { DeleteReferenceImageRequestSchema, DeleteReferenceImageResponseSchema } from "./delete_reference_image_pb";
import { file_vision_assets_v1_delete_reference_image } from "./delete_reference_image_pb";
import type { FinalizeSetDressingReferenceRequestSchema, FinalizeSetDressingReferenceResponseSchema } from "./finalize_set_dressing_reference_pb";
import { file_vision_assets_v1_finalize_set_dressing_reference } from "./finalize_set_dressing_reference_pb";
import type { ListSetDressingBankRequestSchema, ListSetDressingBankResponseSchema } from "./list_set_dressing_bank_pb";
import { file_vision_assets_v1_list_set_dressing_bank } from "./list_set_dressing_bank_pb";
import type { DeleteSetDressingReferenceRequestSchema, DeleteSetDressingReferenceResponseSchema } from "./delete_set_dressing_reference_pb";
import { file_vision_assets_v1_delete_set_dressing_reference } from "./delete_set_dressing_reference_pb";
import type { FinalizeColorPresetRequestSchema, FinalizeColorPresetResponseSchema } from "./finalize_color_preset_pb";
import { file_vision_assets_v1_finalize_color_preset } from "./finalize_color_preset_pb";
import type { ListColorPresetsRequestSchema, ListColorPresetsResponseSchema } from "./list_color_presets_pb";
import { file_vision_assets_v1_list_color_presets } from "./list_color_presets_pb";
import type { DeleteColorPresetRequestSchema, DeleteColorPresetResponseSchema } from "./delete_color_preset_pb";
import { file_vision_assets_v1_delete_color_preset } from "./delete_color_preset_pb";
import type { SetImageMaskRegionsRequestSchema, SetImageMaskRegionsResponseSchema } from "./set_image_mask_regions_pb";
import { file_vision_assets_v1_set_image_mask_regions } from "./set_image_mask_regions_pb";
import type { SetProjectImageFrameNumberRequestSchema, SetProjectImageFrameNumberResponseSchema } from "./set_project_image_frame_number_pb";
import { file_vision_assets_v1_set_project_image_frame_number } from "./set_project_image_frame_number_pb";
import type { SetProjectImageDescriptionRequestSchema, SetProjectImageDescriptionResponseSchema } from "./set_project_image_description_pb";
import { file_vision_assets_v1_set_project_image_description } from "./set_project_image_description_pb";
import type { MoveProjectImageRequestSchema, MoveProjectImageResponseSchema } from "./move_project_image_pb";
import { file_vision_assets_v1_move_project_image } from "./move_project_image_pb";
import type { BulkMoveProjectImagesRequestSchema, BulkMoveProjectImagesResponseSchema } from "./bulk_move_project_images_pb";
import { file_vision_assets_v1_bulk_move_project_images } from "./bulk_move_project_images_pb";
import type { ReorderProjectImagesRequestSchema, ReorderProjectImagesResponseSchema } from "./reorder_project_images_pb";
import { file_vision_assets_v1_reorder_project_images } from "./reorder_project_images_pb";
import type { DeleteProjectImageRequestSchema, DeleteProjectImageResponseSchema } from "./delete_project_image_pb";
import { file_vision_assets_v1_delete_project_image } from "./delete_project_image_pb";
import type { DeleteUncategorizedImagesRequestSchema, DeleteUncategorizedImagesResponseSchema } from "./delete_uncategorized_images_pb";
import { file_vision_assets_v1_delete_uncategorized_images } from "./delete_uncategorized_images_pb";

/**
 * Describes the file vision/assets/v1/assets_service.proto.
 */
export const file_vision_assets_v1_assets_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_vision_assets_v1_finalize_project_image, file_vision_assets_v1_rotate_project_image, file_vision_assets_v1_list_project_images, file_vision_assets_v1_categorize_project_images, file_vision_assets_v1_finalize_reference_image, file_vision_assets_v1_list_reference_bank, file_vision_assets_v1_delete_reference_image, file_vision_assets_v1_finalize_set_dressing_reference, file_vision_assets_v1_list_set_dressing_bank, file_vision_assets_v1_delete_set_dressing_reference, file_vision_assets_v1_finalize_color_preset, file_vision_assets_v1_list_color_presets, file_vision_assets_v1_delete_color_preset, file_vision_assets_v1_set_image_mask_regions, file_vision_assets_v1_set_project_image_frame_number, file_vision_assets_v1_set_project_image_description, file_vision_assets_v1_move_project_image, file_vision_assets_v1_bulk_move_project_images, file_vision_assets_v1_reorder_project_images, file_vision_assets_v1_delete_project_image, file_vision_assets_v1_delete_uncategorized_images]);

/**
 * @generated from service protos.vision.assets.v1.VisionAssets
 */
export const VisionAssets: GenService<{
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.FinalizeProjectImage
   */
  finalizeProjectImage: {
    methodKind: "unary";
    input: typeof FinalizeProjectImageRequestSchema;
    output: typeof FinalizeProjectImageResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.RotateProjectImage
   */
  rotateProjectImage: {
    methodKind: "unary";
    input: typeof RotateProjectImageRequestSchema;
    output: typeof RotateProjectImageResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.ListProjectImages
   */
  listProjectImages: {
    methodKind: "unary";
    input: typeof ListProjectImagesRequestSchema;
    output: typeof ListProjectImagesResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.CategorizeProjectImages
   */
  categorizeProjectImages: {
    methodKind: "unary";
    input: typeof CategorizeProjectImagesRequestSchema;
    output: typeof CategorizeProjectImagesResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.FinalizeReferenceImage
   */
  finalizeReferenceImage: {
    methodKind: "unary";
    input: typeof FinalizeReferenceImageRequestSchema;
    output: typeof FinalizeReferenceImageResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.ListReferenceBank
   */
  listReferenceBank: {
    methodKind: "unary";
    input: typeof ListReferenceBankRequestSchema;
    output: typeof ListReferenceBankResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.DeleteReferenceImage
   */
  deleteReferenceImage: {
    methodKind: "unary";
    input: typeof DeleteReferenceImageRequestSchema;
    output: typeof DeleteReferenceImageResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.FinalizeSetDressingReference
   */
  finalizeSetDressingReference: {
    methodKind: "unary";
    input: typeof FinalizeSetDressingReferenceRequestSchema;
    output: typeof FinalizeSetDressingReferenceResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.ListSetDressingBank
   */
  listSetDressingBank: {
    methodKind: "unary";
    input: typeof ListSetDressingBankRequestSchema;
    output: typeof ListSetDressingBankResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.DeleteSetDressingReference
   */
  deleteSetDressingReference: {
    methodKind: "unary";
    input: typeof DeleteSetDressingReferenceRequestSchema;
    output: typeof DeleteSetDressingReferenceResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.FinalizeColorPreset
   */
  finalizeColorPreset: {
    methodKind: "unary";
    input: typeof FinalizeColorPresetRequestSchema;
    output: typeof FinalizeColorPresetResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.ListColorPresets
   */
  listColorPresets: {
    methodKind: "unary";
    input: typeof ListColorPresetsRequestSchema;
    output: typeof ListColorPresetsResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.DeleteColorPreset
   */
  deleteColorPreset: {
    methodKind: "unary";
    input: typeof DeleteColorPresetRequestSchema;
    output: typeof DeleteColorPresetResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.SetImageMaskRegions
   */
  setImageMaskRegions: {
    methodKind: "unary";
    input: typeof SetImageMaskRegionsRequestSchema;
    output: typeof SetImageMaskRegionsResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.SetProjectImageFrameNumber
   */
  setProjectImageFrameNumber: {
    methodKind: "unary";
    input: typeof SetProjectImageFrameNumberRequestSchema;
    output: typeof SetProjectImageFrameNumberResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.SetProjectImageDescription
   */
  setProjectImageDescription: {
    methodKind: "unary";
    input: typeof SetProjectImageDescriptionRequestSchema;
    output: typeof SetProjectImageDescriptionResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.MoveProjectImage
   */
  moveProjectImage: {
    methodKind: "unary";
    input: typeof MoveProjectImageRequestSchema;
    output: typeof MoveProjectImageResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.BulkMoveProjectImages
   */
  bulkMoveProjectImages: {
    methodKind: "unary";
    input: typeof BulkMoveProjectImagesRequestSchema;
    output: typeof BulkMoveProjectImagesResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.ReorderProjectImages
   */
  reorderProjectImages: {
    methodKind: "unary";
    input: typeof ReorderProjectImagesRequestSchema;
    output: typeof ReorderProjectImagesResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.DeleteProjectImage
   */
  deleteProjectImage: {
    methodKind: "unary";
    input: typeof DeleteProjectImageRequestSchema;
    output: typeof DeleteProjectImageResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.assets.v1.VisionAssets.DeleteUncategorizedImages
   */
  deleteUncategorizedImages: {
    methodKind: "unary";
    input: typeof DeleteUncategorizedImagesRequestSchema;
    output: typeof DeleteUncategorizedImagesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_vision_assets_v1_assets_service, 0);

